import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";

/**
 * El freno de mano de los carriles que escriben solos en los equipos del
 * cliente. **Solo para; no enciende.** Soltar el freno no arranca el carril:
 * si su variable de entorno está apagada sigue sin correr. Encender es una
 * decisión de despliegue, a propósito.
 */
export interface CarrilFrenable {
  carril: string;
  descripcion: string;
  frenado: boolean;
  motivo: string | null;
  puesto_por: string | null;
  puesto_en: string | null;
}

export function useFrenos() {
  return useQuery({
    queryKey: ["frenos"],
    queryFn: ({ signal }) =>
      api<{ carriles: CarrilFrenable[] }>("/api/v1/srps/frenos/estado", {
        signal,
      }),
    // Se relee solo: si otro operador frena durante un incidente, quien tenga
    // la pantalla abierta tiene que verlo sin recargar.
    refetchInterval: 30_000,
  });
}

export function useAccionarFreno() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      carril,
      frenar,
      motivo,
    }: {
      carril: string;
      frenar: boolean;
      motivo?: string;
    }) =>
      api<CarrilFrenable>(`/api/v1/srps/frenos/${encodeURIComponent(carril)}`, {
        method: "POST",
        body: { frenar, motivo },
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["frenos"] });
    },
  });
}
